import { isNodeActive, wrapOrModifyListNode, getNodeAttrs, setActiveTool } from "../../../commands/custom-commands";
import { wrapInList, sinkListItem } from "prosemirror-schema-list";
import { customSchema, validOrderedListTypes } from "../../../schemas/custom-schema";

export default class OrderedListTool {
  constructor(editorView, containerElement) {
    this.view = editorView;
    this.buildContainer();
    this.buildDialog();
    this.bindActions();
    containerElement.appendChild(this.containerElement);
    this.update(editorView);
  }

  buildContainer() {
    this.containerElement = document.createElement("div");
    this.containerElement.className = "editor-button-container";
    this.buttonElement = document.createElement("button");
    this.buttonElement.setAttribute("type", "button");
    this.buttonElement.className = "editor-toolbar-button";
    this.buttonElement.style.anchorName = "--ordered-list-anchor";
    this.buttonElement.dataset.action = "ordered-list";
    this.buttonElement.setAttribute("aria-expanded", "false");
    this.buttonElement.title = "Lista ordenada";
    const iconSpan = document.createElement("span"),
      labelSpan = document.createElement("span");
    iconSpan.textContent = "Lista ordenada";
    labelSpan.className = "oculto-visual";
    labelSpan.textContent = "Lista ordenada";
    this.buttonElement.appendChild(iconSpan);
    this.buttonElement.appendChild(labelSpan);
    this.containerElement.appendChild(this.buttonElement);
  }

  buildDialog() {
    const targetInputContainer = document.createElement("div"),
      targetLabel = document.createElement("label"),
      buttonsContainer = document.createElement("div");

    this.dialogElement = document.createElement("div");
    this.dialogElement.className = "editor-dialog";
    this.dialogElement.style.positionAnchor = "--ordered-list-anchor";
    this.typeDropdown = document.createElement("select");
    this.typeDropdown.className = "editor-dropdown";
    const options = validOrderedListTypes.map(type => {
      const option = document.createElement("option");
      option.value = type.value;
      option.label = type.label;
      this.typeDropdown.appendChild(option);
    });

    this.submitButton = document.createElement("button");
    this.submitButton.type = "button";
    this.submitButton.className = "editor-button";
    this.submitButton.textContent = "Agregar";

    buttonsContainer.className = "editor-buttons-container";
    buttonsContainer.appendChild(this.submitButton);

    this.dialogElement.appendChild(this.typeDropdown);
    this.dialogElement.appendChild(buttonsContainer);

    this.containerElement.appendChild(this.dialogElement);
  }

  bindActions() {
    this.buttonAction = this.buttonClickCallback();
    this.submitAction = this.submitButtonClickCallback();
    this.buttonElement.addEventListener("click", this.buttonAction);
    this.submitButton.addEventListener("click", this.submitAction);
  }

  update(view) {
    const nodeAttrs = getNodeAttrs(view.state, customSchema.nodes.orderedList),
      isEnabled = wrapOrModifyListNode(customSchema.nodes.orderedList, { type: "decimal" })(view.state, null);
    if(!!nodeAttrs) { 
      this.typeDropdown.value = nodeAttrs.type;
      this.buttonElement.setAttribute("aria-pressed", "true");
    } else {
      this.typeDropdown.value = this.typeDropdown.options[0].value;
      this.buttonElement.setAttribute("aria-pressed", "false");
    }

    this.buttonElement.disabled = !isEnabled;
  }

  destroy() {
    this.buttonElement.removeEventListener("click", this.buttonAction);
    this.submitButton.removeEventListener("submit", this.submitAction);
    this.containerElement.remove();
    this.containerElement = null;
    this.buttonElement = null;
    this.urlInput = null;
    this.targetInput = null;
    this.submitButton = null;
    this.dialogElement = null;
    this.buttonAction = null;
    this.submitAction = null;
  }

  buttonClickCallback() {
    return () => {
      setActiveTool(this.buttonElement)(this.view.state, this.view.dispatch);
    }
  }

  submitButtonClickCallback() {
    return (event) => {
      event.preventDefault();
      const { value: typeValue } = this.typeDropdown;

      if(!validOrderedListTypes.map(type => type.value).includes(typeValue)) {
        return false;
      }

      wrapOrModifyListNode(customSchema.nodes.orderedList, { type: typeValue })(this.view.state, this.view.dispatch);
      setActiveTool(null)(this.view.state, this.view.dispatch);
      this.view.focus();
    }
  }
}
